<template>
  <swiper class="myBanner" ref="myBanner" :options="bannerOptions">
		<swiper-slide v-for="bannerItem in bannerList" :key="bannerItem.id">
			<img :src="bannerItem.banner" alt="">
      <!-- ../../assets/banner02.jpg -->
		</swiper-slide>
    <div class="banner-pagination" slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
export default {
	name: 'banner',
	data() {
		return {
        bannerOptions:{
					loop: true,
					autoplay: {
						delay: 3000,
					},
					speed: 600,
          pagination:{
            el: '.banner-pagination'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl:'.swiper-button-prev',
          }
        },
// 				bgImg: {
// 					backgroundImage: "url("+require("")+")"
// 				}
        bannerList:[]
		};
	},
  created() {
    // this.axios({
    //   method: "post",
    //   url: "http://ad.dinovor.com/banner/websiteBanners",
    //   data: {
    //     type: 1
    //   }
    // }).then(function(res) {
    //   console.log(res)
    // }).catch(function(error){

    // })
    var that = this;
    that.$api.post(
      'banner/websiteBanners',
      {
        type: 1
      },
      function(res) {
        if(res.data.rtnCode == 200){
          var list = res.data.data;
          for(var i=0;i<list.length;i++){
            if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
              list[i].banner = list[i].phone_banner;
            }else{
              list[i].banner = list[i].pic;
            }
          }
          that.bannerList = list;
        }else{
          alert(res.data.msg);
        }

      }
    );
  }
}
</script>

<style>
.myBanner .banner-pagination{
  position: absolute;
  z-index: 2;
}
.myBanner .swiper-pagination-bullet{
  border-radius: 0;
  width: 40px;
  height: 2px;
  background: #cecece;
}
/* .myBanner{
	margin-top: 60px;
} */
.myBanner .swiper-slide{
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
}
.myBanner .swiper-button-prev,.myBanner .swiper-button-next{
  --swiper-navigation-size: 25px;
  color: #fff;
  background: rgba(0,0,0,.6);
  z-index: 2;
	width: 56px;
	height: 56px;
	padding: 0;
	margin-top: -28px;
	overflow: hidden;
}
.myBanner .swiper-button-prev{
  left: 0;
}
.myBanner .swiper-button-prev::after,.myBanner .swiper-button-next::after{
	transition: all .5s ease;
}
.myBanner .swiper-button-next{
  right: 0;
}
.myBanner .swiper-button-prev::before,.myBanner .swiper-button-next::before{
	font-family: element-icons!important;
	font-size: 36px;
	position: absolute;
	top: 50%;
	transform: translate(-50%,-50%);
	opacity: 0;
	transition: all .5s ease;
}
.myBanner .swiper-button-prev::before{
	content: '\E6EA';
	left: 100%;
}
.myBanner .swiper-button-next::before{
	content: '\E6E9';
	left: 0;
}
.myBanner .swiper-button-prev:hover::before,.myBanner .swiper-button-next:hover::before{
	left: 50%;
	opacity: 1;
}
.myBanner .swiper-button-prev:hover::after,.myBanner .swiper-button-next:hover::after{
	opacity: 0;
}
@media (max-width: 992px){

}
</style>



// WEBPACK FOOTER //
// src/components/index/banner.vue